import { Box, BoxProps, InputLabel } from "@mui/material";
import React, { ReactNode } from "react";
import { useTheme } from "../../hooks";
import { CommonProps } from "@mui/material/OverridableComponent";

export const DataDisplay = (props: { label?: ReactNode; type?: "normal" | "textarea"; children?: ReactNode, style?: object }) => {
  let content: ReactNode = props.children;
  const theme = useTheme();

  if (props.type === "textarea") {
    content = <pre style={{ whiteSpace: "pre-wrap", wordBreak: "break-all" }}>{props.children}</pre>;
  }

  return (
    <Box borderBottom={1} borderColor={theme.palette.border.main} width="100%">
      <InputLabel shrink={true}>{props.label}</InputLabel>
      <Box minHeight="2.3em" style={props.style} sx={{ overflowWrap: "break-word" }}>
        {content}
      </Box>
    </Box>
  );
};
